var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-card",
        { attrs: { outlined: "", elevation: "1" } },
        [
          _c(
            "v-toolbar",
            { attrs: { dense: "", flat: "", color: "primary", dark: "" } },
            [
              _c("v-toolbar-title", [_vm._v("Completion Reports")]),
              _c("v-spacer"),
              _c(
                "v-menu",
                {
                  attrs: { "offset-y": "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function({ on, attrs }) {
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              _vm._b(
                                {
                                  attrs: { color: "white", small: "", text: "" }
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-file-download")
                              ]),
                              _vm._v(" Template ")
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c(
                    "v-list",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-list-item",
                        {
                          on: {
                            click: function($event) {
                              return _vm.downloadTemplate("xlsx")
                            }
                          }
                        },
                        [
                          _c(
                            "v-list-item-icon",
                            { staticClass: "mr-2" },
                            [_c("v-icon", [_vm._v("mdi-file-excel")])],
                            1
                          ),
                          _c("v-list-item-title", [_vm._v("XLSX template")])
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        {
                          on: {
                            click: function($event) {
                              return _vm.downloadTemplate("json")
                            }
                          }
                        },
                        [
                          _c(
                            "v-list-item-icon",
                            { staticClass: "mr-2" },
                            [_c("v-icon", [_vm._v("mdi-code-json")])],
                            1
                          ),
                          _c("v-list-item-title", [_vm._v("JSON template")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "white", small: "", text: "" },
                  on: {
                    click: function($event) {
                      _vm.importDialog = true
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("mdi-database-import")
                  ]),
                  _vm._v(" Import ")
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "white",
                    small: "",
                    text: "",
                    to: "/completion-reports/create"
                  }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [_vm._v("mdi-plus")]),
                  _vm._v(" New Report ")
                ],
                1
              )
            ],
            1
          ),
          _c("import-dialog", {
            on: { imported: _vm.fetchData },
            model: {
              value: _vm.importDialog,
              callback: function($$v) {
                _vm.importDialog = $$v
              },
              expression: "importDialog"
            }
          }),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          dense: "",
                          outlined: "",
                          "hide-details": "",
                          label: "Search (Ref No / Project)",
                          clearable: "",
                          "prepend-inner-icon": "mdi-magnify"
                        },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.data,
                  loading: _vm.loading,
                  options: _vm.options,
                  "server-items-length": _vm.total,
                  "footer-props": { itemsPerPageOptions: [10, 25, 50, 100] },
                  dense: ""
                },
                on: {
                  "update:options": function($event) {
                    _vm.options = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.date",
                    fn: function({ item }) {
                      return [
                        _vm._v(" " + _vm._s(_vm.formatDate(item.date)) + " ")
                      ]
                    }
                  },
                  {
                    key: "item.locked_at",
                    fn: function({ item }) {
                      return [
                        _c(
                          "v-chip",
                          {
                            attrs: {
                              color: item.locked_at ? "red" : "green",
                              small: "",
                              dark: ""
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(item.locked_at ? "Locked" : "Open") +
                                " "
                            )
                          ]
                        )
                      ]
                    }
                  },
                  {
                    key: "item.actions",
                    fn: function({ item }) {
                      return [
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "", small: "" },
                            on: {
                              click: function($event) {
                                return _vm.view(item.id)
                              }
                            }
                          },
                          [
                            _c("v-icon", { attrs: { color: "purple" } }, [
                              _vm._v("mdi-eye")
                            ])
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              icon: "",
                              small: "",
                              disabled: item.locked_at
                            },
                            on: {
                              click: function($event) {
                                return _vm.edit(item.id)
                              }
                            }
                          },
                          [
                            _c(
                              "v-icon",
                              { attrs: { color: "yellow darken-3" } },
                              [_vm._v("mdi-pencil")]
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              icon: "",
                              small: "",
                              color: "red",
                              disabled: item.locked_at
                            },
                            on: {
                              click: function($event) {
                                return _vm.remove(item.id, item)
                              }
                            }
                          },
                          [_c("v-icon", [_vm._v("mdi-delete")])],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "", small: "" },
                            on: {
                              click: function($event) {
                                return _vm.print(item.id, item.ref_no)
                              }
                            }
                          },
                          [
                            _c("v-icon", { attrs: { color: "green" } }, [
                              _vm._v("mdi-printer")
                            ])
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }